import React from "react";
import PropTypes from "prop-types";
import DoubleDial from "../../../components/doubleDials/doubleDials";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import MoneyDisplay from "../../../components/moneyDisplay/moneyDisplay";
// import PercentChanged from '../../../components/percentChanged/percentChanged'
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { formatCurrencySymbol, formatGoalTitle } from "../../../utils/formatters";

export class DonutForecastModule extends React.Component {
  render() {
    return (
      <SectionContainer title={this.props.title}>
        <ReactTooltip />
        <div className="left" style={{ ...styles.left, width: this.props.width !== undefined ? "25%" : "50%" }}>
          {!this.props.currentUser.singleLocation ? (
            <p className="metric-location" style={styles.metric.location}>
              {this.props.metricLocation}
            </p>
          ) : (
            <p className="metric-location" style={styles.metric.location} />
          )}

          <p className="metric-title" style={styles.metric.title}>
            {formatGoalTitle(this.props.metricTitle)}
          </p>
          <DoubleDial
            currentData={[
              { name: "Current", value: this.props.value },
              { name: "Remain", value: 100 - this.props.value }
            ]}
            pacingData={[
              { name: "Pacing", value: this.props.forecastValue },
              { name: "Remain", value: 100 - this.props.forecastValue }
            ]}
          />
        </div>
        <div className="right" style={{ ...styles.right, width: this.props.width !== undefined ? "25%" : "50%" }}>
          <p className="total" style={styles.total}>
            Current
          </p>
          <MoneyDisplay
            value={this.props.goalCurrentVal}
            size={24}
            currency={formatCurrencySymbol(this.props.metricTitle, this.props.currencySymbol !== undefined && this.props.currencySymbol)}
          />
          <p className="total" style={styles.total}>
            Forecast{" "}
            <a href="https://intercom.help/ikizmet/en/articles/3176686-goal-forecasting" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon data-tip="Click here to learn how this forecast is calculated." icon={faQuestionCircle} style={{ color: "#8ac934" }} />
            </a>
          </p>
          <MoneyDisplay
            value={this.props.currentValPacing}
            size={24}
            currency={formatCurrencySymbol(this.props.metricTitle, this.props.currencySymbol)}
            color={"#fd6a3e"}
          />
          <p className="total" style={styles.total}>
            Goal
          </p>
          <MoneyDisplay
            value={this.props.goalUsesPercent ? this.props.goalCurrentVal + this.props.goalRemainValue : this.props.goalValue}
            size={24}
            currency={formatCurrencySymbol(this.props.metricTitle, this.props.currencySymbol)}
            color={"#a9c0e2"}
          />
        </div>
      </SectionContainer>
    );
  }
}

var styles = {
  sectionContainer: {
    width: "600px"
  },
  left: {
    width: "50%",
    float: "left"
  },
  right: {
    width: "50%",
    float: "left",
    paddingTop: "35px"
  },
  forecast: {
    color: "#fd6a3e",
    fontSize: "20px",
    paddingTop: "5px",
    percent: {
      fontSize: "12px"
    }
  },
  forecastIcon: {
    width: "5px",
    height: "16px",
    backgroundColor: "#fd6a3e",
    display: "block",
    float: "left",
    marginTop: "6px",
    marginRight: "7px"
  },
  metric: {
    title: {
      color: "#8791a0",
      fontsize: "16px",
      textTransform: "uppercase",
      fontWeight: "700",
      lineHeight: "12px",
      whiteSpace: "nowrap",
      position: "relative",
      top: "-6px",
      marginBottom: "25px",
      fontSize: "12px"
    },
    location: {
      color: "#87919f",
      fontSize: "12px",
      lineHeight: "15px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  },
  total: {
    color: "#787c87",
    lineHeight: "10px",
    paddingTop: "15px"
  }
};

export default DonutForecastModule;

DonutForecastModule.propTypes = {
  forecastValue: PropTypes.number,
  value: PropTypes.number,
  title: PropTypes.string,
  metricTitle: PropTypes.string,
  metricLocation: PropTypes.string,
  goalCurrentVal: PropTypes.number,
  goalRemainValue: PropTypes.number,
  currencySymbol: PropTypes.string,
  currentValPacing: PropTypes.number,
  currentUser: PropTypes.object,
  width: PropTypes.string,
  goalUsesPercent: PropTypes.bool,
  goalValue: PropTypes.number
};
